import React, { useState, Fragment } from 'react';
import Accordion from 'b2b-ui-components-lib/lib/components/accordion';
import Input from 'b2b-ui-components-lib/lib/components/input';
import KnowMorePopup from 'home/view/upgrade-order/components/common/KnowMorePopup';

import { SERVICE_TYPE, MEDIA_TYPES } from 'home/view/upgrade-order/constants';

import dotGreen from 'assests/svg/dot-green.svg';
import classNames from 'classnames';

const TitleComponent = React.memo(({ isExpanded, currentBw, serviceType, media, maxFeasibleBw }) => {
  const getServiceType = () => {
    if (serviceType === SERVICE_TYPE.PARTIALLY_MANAGED) {
      return 'Partially Managed';
    }

    return serviceType.toTitleCase();
  };

  return (
    <React.Fragment>
      {isExpanded ? (
        <div className="upgrade-header-open">
          <Fragment>
            <div className="title pad-bottom-0">New Site Details</div>
            <label className="field_label">Please provide the new site details to get accurate network feasibility report.</label>
          </Fragment>
        </div>
      ) : (
        <Fragment>
          <div className="upgrade-header-open">
            <div className="title pad-bottom-0">{'New Site Details'}</div>
            <label className="field_label">{'Please provide the new site details to get accurate network feasibility report.'}</label>
          </div>
          <ul className="upgrade-header-closed" style={{ alignItems: 'center' }}>
            <li>
              <span>Feasibility Status:</span>
              <img src={dotGreen} alt="dot-green" style={{ margin: '0 5px' }} />
              <span>{`Feasible Upto ${maxFeasibleBw} Mbps`}</span>
            </li>
            <li>{`Media Type: ${media}`}</li>
            {currentBw && <li key={currentBw}>{`Required Bandwidth: ${currentBw}`}</li>}
            {serviceType && <li key={serviceType}>{`Service Type: ${getServiceType()}`}</li>}
          </ul>
        </Fragment>
      )}
    </React.Fragment>
  );
});

const UpgradeOrderDetailsAccordionSummary = ({ orderDetail }) => {
  const [accordionMeta, setAccordionMeta] = useState({
    isExpanded: true
  });

  const [showKnowMorePopup, setShowKnowMorePopup] = useState(false);

  return (
    <div className="upgrade-order-details upgrade-accordion">
      {showKnowMorePopup && (
        <KnowMorePopup
          setShowManageServices={setShowKnowMorePopup}
          productName={orderDetail?.lead?.connectivityLineItems?.[0]?.serviceType === 'DEDICATED_INTERNET' ? 'INTERNET' : 'MPLS'}
        />
      )}
      <Accordion
        autoScrollOnExpand={false}
        title={
          <TitleComponent
            isExpanded={accordionMeta.isExpanded}
            currentBw={orderDetail?.lead?.connectivityLineItems?.[0]?.planDetail?.speed}
            serviceType={orderDetail?.lead?.connectivityLineItems?.[0]?.planDetail?.service?.toTitleCase()}
            media={orderDetail?.lead?.connectivityLineItems?.[0]?.selectedMedia?.[0]?.media}
            maxFeasibleBw={orderDetail?.lead?.connectivityLineItems?.[0]?.selectedMedia?.[0]?.maxBandwidth}
          />
        }
        isExpanded={accordionMeta.isExpanded}
        onExpandClick={() =>
          setAccordionMeta((accordionMeta) => ({
            ...accordionMeta,
            isExpanded: !accordionMeta.isExpanded
          }))
        }
        variant="round"
      >
        <div className="upgrade-body">
          <div className="row margin-bottom">
            <div className="flg-lg-6 flg-md-6 flg-sm-12">
              <label>New Installation Address</label>
              <div style={{ marginTop: 5 }}>{orderDetail?.lead?.connectivityLineItems?.[0]?.address?.addressLine1}</div>
            </div>
            <div className="flg-lg-6 flg-md-6 flg-sm-12">
              <label>Feasibility Status</label>
              <div style={{ marginTop: 5 }}>
                <Fragment>
                  <img src={dotGreen} alt="dot-green" style={{ margin: '0 5px 0 0' }} />
                  <span>{`Feasible Upto ${orderDetail?.lead?.connectivityLineItems?.[0]?.selectedMedia?.[0]?.maxBandwidth} Mbps`}</span>
                </Fragment>
              </div>
            </div>
            {/* )} */}
          </div>
          <div className="row">
            <div className="flg-lg-6 flg-md-6 flg-sm-12">
              <div
                className={classNames({
                  'control_group bw_selectbox': true
                })}
              >
                <Input placeholder="" label="Required Bandwidth" value={orderDetail?.lead?.connectivityLineItems?.[0]?.planDetail?.speed} required touched disabled />
              </div>
            </div>
            <div className="flg-lg-6 flg-md-6 flg-sm-12">
              <div className="control_group">
                <Input placeholder="" label="Media Type" value={orderDetail?.lead?.connectivityLineItems?.[0]?.selectedMedia?.[0]?.media} required touched disabled />
                {orderDetail?.lead?.connectivityLineItems?.[0]?.selectedMedia?.[0]?.media === MEDIA_TYPES.OFFNET && (
                  <div className="info-text additional_info">
                    <span className="material-icons-outlined additional_info_icon">info</span>
                    &nbsp; Additional CAPEX charges may apply
                  </div>
                )}
                {orderDetail?.lead?.connectivityLineItems?.[0]?.selectedMedia?.[0]?.media === MEDIA_TYPES.THIRD_PARTY && (
                  <div className="info-text additional_info">
                    <span className="material-icons-outlined additional_info_icon">info</span>
                    &nbsp; Additional Third Party charges may apply
                  </div>
                )}
              </div>
            </div>
            <div className="flg-lg-6 flg-md-6 flg-sm-12">
              <div className="control_group">
                <Input placeholder="" label="Service Type" value={orderDetail?.lead?.connectivityLineItems?.[0]?.planDetail?.service?.toTitleCase()} required touched disabled />
              </div>
              <div className="know_more_container">
                <span className="know_more" onClick={() => setShowKnowMorePopup(true)}>
                  <i className="material-icons-outlined">info</i> Know more
                </span>
              </div>
            </div>
          </div>
          <div className="site-contact-label">Site Contact Person Details</div>
          <div className="row">
            <div className="flg-lg-6 flg-md-6 flg-sm-12">
              <Input
                type="text"
                label="Site Contact Name*"
                name="siteContactName"
                value={orderDetail?.lead?.connectivityLineItems?.[0]?.siteIncharge?.firstName}
                required
                touched
                disabled
              />
            </div>
            <div className="flg-lg-6 flg-md-6 flg-sm-12">
              <Input
                type="text"
                label="Site Contact Number*"
                name="siteContactNumber"
                value={orderDetail?.lead?.connectivityLineItems?.[0]?.siteIncharge?.phoneNumber}
                required
                touched
                disabled
              />
            </div>
            <div className="flg-lg-6 flg-md-6 flg-sm-12">
              <Input type="text" label="Site Contact Person Email*" name="siteContactEmail" value={orderDetail?.customerEmail} required touched disabled />
            </div>
          </div>
        </div>
      </Accordion>
    </div>
  );
};

export default UpgradeOrderDetailsAccordionSummary;
